import { pushEvent } from '../pushEvent';

export const pushStartDecisionToolEvent = () => {
	pushEvent({
		event: 'interaction.component.decisionTool',
		events: {
			category: 'interaction.component.decisionTool',
			action: 'start_decision_tool',
			label: window.location.pathname,
		},
		page: {
			dt_current_step_number: undefined,
			dt_current_step_name: undefined,
			dt_step_answer: undefined,
			dt_step_result: undefined,
		},
	});
};

export const pushNextStepEvent = ({
	answerTitle,
	questionId,
	questionTitle,
}: {
	questionId: string;
	questionTitle: string;
	answerTitle: string | Array<string> | undefined;
}) => {
	pushEvent({
		event: 'interaction.component.decisionTool',
		events: {
			category: 'interaction.component.decisionTool',
			action: 'next_step',
			label: window.location.pathname,
		},
		page: {
			dt_current_step_number: questionId,
			dt_current_step_name: questionTitle,
			dt_step_answer: Array.isArray(answerTitle)
				? answerTitle.join(';')
				: answerTitle,
			dt_step_result: undefined,
		},
	});
};

export const pushPreviousStepEvent = ({
	questionId,
	questionTitle,
}: {
	questionId: string;
	questionTitle: string;
}) => {
	pushEvent({
		event: 'interaction.component.decisionTool',
		events: {
			category: 'interaction.component.decisionTool',
			action: 'previous_step',
			label: window.location.pathname,
		},
		page: {
			dt_current_step_number: questionId,
			dt_current_step_name: questionTitle,
			dt_step_answer: undefined,
			dt_step_result: undefined,
		},
	});
};

export const pushQuiestionHelpExpandEvent = ({
	quiestionId,
	questionTitle,
}: {
	quiestionId: string;
	questionTitle: string;
}) => {
	pushEvent({
		event: 'interaction.component.decisionTool',
		events: {
			category: 'interaction.component.decisionTool',
			action: 'question_help_expand',
			label: window.location.pathname,
		},
		page: {
			dt_current_step_number: quiestionId,
			dt_current_step_name: questionTitle,
			dt_step_answer: undefined,
			dt_step_result: undefined,
		},
	});
};

export const pushQuiestionHelpCollapseEvent = ({
	quiestionId,
	questionTitle,
}: {
	quiestionId: string;
	questionTitle: string;
}) => {
	pushEvent({
		event: 'interaction.component.decisionTool',
		events: {
			category: 'interaction.component.decisionTool',
			action: 'question_help_collapse',
			label: window.location.pathname,
		},
		page: {
			dt_current_step_number: quiestionId,
			dt_current_step_name: questionTitle,
			dt_step_answer: undefined,
			dt_step_result: undefined,
		},
	});
};

export const pushAnswerHelpExpandEvent = ({
	currentQuestionId,
	answerTitle,
	questionTitle,
}: {
	currentQuestionId: string;
	answerTitle: string;
	questionTitle: string;
}) => {
	pushEvent({
		event: 'interaction.component.decisionTool',
		events: {
			category: 'interaction.component.decisionTool',
			action: 'answer_help_expand',
			label: window.location.pathname,
		},
		page: {
			dt_current_step_number: currentQuestionId,
			dt_current_step_name: questionTitle,
			dt_step_answer: answerTitle,
			dt_step_result: undefined,
		},
	});
};

export const pushAnswerHelpCollapseEvent = ({
	currentQuestionId,
	answerTitle,
	questionTitle,
}: {
	currentQuestionId: string;
	answerTitle: string;
	questionTitle: string;
}) => {
	pushEvent({
		event: 'interaction.component.decisionTool',
		events: {
			category: 'interaction.component.decisionTool',
			action: 'answer_help_collapse',
			label: window.location.pathname,
		},
		page: {
			dt_current_step_number: currentQuestionId,
			dt_current_step_name: questionTitle,
			dt_step_answer: answerTitle,
			dt_step_result: undefined,
		},
	});
};

export const pushViewResultEvent = ({
	action,
	givenAnswersSearchParamsString,
}: {
	action: 'view_result' | 'view_result_midflow';
	givenAnswersSearchParamsString: string;
}) => {
	pushEvent({
		event: 'interaction.component.decisionTool',
		events: {
			category: 'interaction.component.decisionTool',
			action,
			label: window.location.pathname,
		},
		page: {
			dt_current_step_number: undefined,
			dt_current_step_name: undefined,
			dt_step_answer: undefined,
			dt_step_result: givenAnswersSearchParamsString,
		},
	});
};

export const pushResultAccordionEvent = ({
	resultTitle,
	opening,
}: {
	resultTitle: string;
	opening: boolean;
}) => {
	pushEvent({
		event: 'interaction.component.decisionTool',
		events: {
			category: 'interaction.component.decisionTool',
			action: `${opening ? 'accordion_open' : 'accordion_close'} - ${resultTitle}`,
			label: window.location.pathname,
		},
		page: {
			dt_current_step_number: undefined,
			dt_current_step_name: undefined,
			dt_step_answer: undefined,
			dt_step_result: undefined,
		},
	});
};

export const pushRestartEvent = ({
	givenAnswersSearchParamsString,
}: {
	givenAnswersSearchParamsString: string;
}) => {
	pushEvent({
		event: 'interaction.component.decisionTool',
		events: {
			category: 'interaction.component.decisionTool',
			action: 'reset_result',
			label: window.location.pathname,
		},
		page: {
			dt_current_step_number: undefined,
			dt_current_step_name: undefined,
			dt_step_answer: undefined,
			dt_step_result: givenAnswersSearchParamsString,
		},
	});
};

export const pushSortResultsEvent = ({
	categorisationTitle,
	givenAnswersSearchParamsString,
}: {
	categorisationTitle: string;
	givenAnswersSearchParamsString: string;
}) => {
	pushEvent({
		event: 'interaction.component.decisionTool',
		events: {
			category: 'interaction.component.decisionTool',
			action: `sort_by - ${categorisationTitle}`,
			label: window.location.pathname,
		},
		page: {
			dt_current_step_number: undefined,
			dt_current_step_name: undefined,
			dt_step_answer: undefined,
			dt_step_result: givenAnswersSearchParamsString,
		},
	});
};

export const pushShareResultsExpandEvent = () => {
	pushEvent({
		event: 'interaction.component.shareButton',
		events: {
			category: 'interaction.component.shareButton',
			action: 'share_results_expand',
			label: window.location.pathname,
		},
		page: {},
	});
};

export const pushShareResultsClickEvent = ({ label }: { label: string }) => {
	pushEvent({
		event: 'interaction.component.shareButton',
		events: {
			category: 'interaction.component.shareButton',
			action: 'share_results_click',
			label: window.location.pathname,
		},
		page: {
			selected_share_option: label,
		},
	});
};
